var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.objectUuid
    ? _c(
        "div",
        {
          staticClass: "form tab-content scroll-fire-fox",
          staticStyle: { overflow: "auto", "min-height": "320px" },
          attrs: { id: "form-splicing-tab" },
          on: { click: _vm.closeInsidePlanMenu }
        },
        [
          _c(
            "v-layout",
            {
              ref: "splicingTab",
              staticStyle: { height: "100%", "max-height": "62vh" },
              attrs: { column: "" }
            },
            [
              _c(
                "v-layout",
                {
                  staticStyle: { height: "100%", "min-height": "50px" },
                  attrs: { "align-center": "" }
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { "padding-left": "25px" },
                      attrs: { xs4: "", "justify-start": "" }
                    },
                    [
                      _c("object-options", {
                        attrs: {
                          "object-endpoint": _vm.objectEndpoint,
                          "object-uuid": _vm.objectUuid,
                          side: "origin",
                          "input-label": _vm.$tc("Origin", 1),
                          selection: _vm.origin.selectedObjects,
                          cables: _vm.origin.cables,
                          splitters: _vm.splitters,
                          placeholder: "Origin",
                          "action-type": _vm.actionType,
                          disabled: _vm.visibleData === "insidePlan"
                        },
                        on: {
                          "set-cables": function($event) {
                            _vm.origin.cables = $event
                          },
                          "select-objects": function($event) {
                            return _vm.selectObjects("origin", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs4: "", "align-center": "" } },
                    [
                      _c("toolbar", {
                        attrs: {
                          loading: _vm.loading,
                          disabled: _vm.disabled,
                          "visible-data": _vm.visibleData,
                          "has-inside-plan-button":
                            _vm.objectEndpoint === "closures"
                        },
                        on: {
                          "open-table": _vm.openTable,
                          "switch-visible-data": _vm.switchVisibleData
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "d-flex justify-end",
                      staticStyle: { "padding-right": "25px" },
                      attrs: { xs4: "" }
                    },
                    [
                      _c("object-options", {
                        attrs: {
                          loading: _vm.loading,
                          "object-endpoint": _vm.objectEndpoint,
                          "object-uuid": _vm.objectUuid,
                          side: "destination",
                          "input-label": _vm.$tc("Destination", 1),
                          selection: _vm.destination.selectedObjects,
                          cables: _vm.destination.cables,
                          splitters: _vm.splitters,
                          "action-type": _vm.actionType,
                          placeholder: "Destination",
                          disabled: _vm.visibleData === "insidePlan"
                        },
                        on: {
                          "set-cables": function($event) {
                            _vm.destination.cables = $event
                          },
                          "select-objects": function($event) {
                            return _vm.selectObjects("destination", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.splittersList.length > 0
                ? _c("splitters-list", {
                    attrs: {
                      list: _vm.splittersList,
                      "fiber-colors": _vm.fiberColours,
                      cables: _vm.destination.cables.concat(_vm.origin.cables),
                      splitters: _vm.splitters
                    },
                    on: { "open-menu": _vm.listShowMenu }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fadeInsidePlan", mode: "out-in" } },
                [
                  _vm.visibleData === "splicing"
                    ? _c(
                        "v-layout",
                        {
                          staticClass:
                            "mt-4 pl-3 pr-2 splicing-diagram-container",
                          staticStyle: {
                            height: "100%",
                            position: "relative",
                            "justify-content": "space-between"
                          },
                          attrs: {
                            id:
                              "splicing-connections-container-" + _vm.objectUuid
                          }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "splicing-diagram-origin-container",
                              attrs: { xs4: "" }
                            },
                            _vm._l(_vm.origin.selectedObjects, function(
                              object,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "splicing-origin-table"
                                },
                                [
                                  _c(_vm.getObjectEntriesComponent(object), {
                                    tag: "component",
                                    attrs: {
                                      side: "origin",
                                      object: object,
                                      "opposite-objects":
                                        _vm.destination.selectedObjects,
                                      objects: _vm.origin.selectedObjects,
                                      "selected-item":
                                        _vm.origin.selectedConnectionPoint,
                                      connections: _vm.connections,
                                      "update-counter": _vm.updateCounter,
                                      disabled: _vm.disabled,
                                      "fibers-per-tube": _vm.getFibersPerTube(
                                        object
                                      )
                                    },
                                    on: {
                                      "select-item": function($event) {
                                        return _vm.selectItem("origin", $event)
                                      },
                                      "open-menu": function($event) {
                                        return _vm.showMenu("origin", $event)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "connections-table-container",
                              style: {
                                width: _vm.originWidth,
                                left: _vm.originPosition
                              }
                            },
                            [
                              _vm.visible
                                ? _c("connections", {
                                    attrs: {
                                      "object-uuid": _vm.objectUuid,
                                      "origin-objects": _vm.origin.selectedObjectsCopy.concat(
                                        _vm.originSplitters
                                      ),
                                      "destination-objects": _vm.destination.selectedObjectsCopy.concat(
                                        _vm.destinationSplitters
                                      ),
                                      connections: _vm.connections,
                                      "update-counter": _vm.updateCounter,
                                      splitters: _vm.splitters,
                                      "is-tech-local": _vm.isTechLocal,
                                      equipmentSet: _vm.objectSet,
                                      "selected-origin":
                                        _vm.origin.selectedConnectionPoint,
                                      "selected-destination":
                                        _vm.destination.selectedConnectionPoint
                                    },
                                    on: {
                                      "select-item": _vm.selectItem,
                                      "open-menu": function($event) {
                                        return _vm.connectionsShowMenu($event)
                                      },
                                      "set-splitter": _vm.setSplitterData,
                                      "clear-selected-origin":
                                        _vm.clearSelectedOrigin
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass:
                                "splicing-diagram-destination-container",
                              attrs: { xs4: "" }
                            },
                            _vm._l(_vm.destination.selectedObjects, function(
                              object,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "splicing-destination-table"
                                },
                                [
                                  _c(_vm.getObjectEntriesComponent(object), {
                                    tag: "component",
                                    attrs: {
                                      side: "destination",
                                      object: object,
                                      "opposite-objects":
                                        _vm.origin.selectedObjects,
                                      objects: _vm.destination.selectedObjects,
                                      "selected-item":
                                        _vm.destination.selectedConnectionPoint,
                                      connections: _vm.connections,
                                      "update-counter": _vm.updateCounter,
                                      disabled: _vm.disabled,
                                      destination: true,
                                      "fibers-per-tube": _vm.getFibersPerTube(
                                        object
                                      )
                                    },
                                    on: {
                                      "select-item": function($event) {
                                        return _vm.selectItem(
                                          "destination",
                                          $event
                                        )
                                      },
                                      "open-menu": function($event) {
                                        return _vm.showMenu(
                                          "destination",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("connection-object-menu", {
                            attrs: {
                              "show-menu": _vm.menu.show,
                              x: _vm.menu.x,
                              y: _vm.menu.y,
                              state: _vm.menu.selected.state,
                              disabled: _vm.disabled,
                              "is-fiber": _vm.canShowCircuit,
                              showConnectionOrChange:
                                _vm.showConnectionOrChange,
                              side: _vm.menu.selected.side,
                              "is-expand": _vm.isExpand,
                              "is-tech-local": _vm.isTechLocal,
                              "action-type": _vm.actionType
                            },
                            on: {
                              "close-menu": _vm.closeMenu,
                              "remove-connections": function($event) {
                                _vm.showDeleteConnectionDialog = true
                              },
                              inspect: _vm.inspectConnection,
                              "show-circuit": _vm.showCircuit,
                              "add-connection": _vm.creatingConnectionSameSide,
                              "edit-splitter": _vm.startEditingItem,
                              "connect-to": _vm.connectTo,
                              "view-splitter": _vm.viewSplitter,
                              "change-connection": function($event) {
                                return _vm.changeSelection()
                              },
                              "collapse-list-splitter":
                                _vm.collapseListSplitter,
                              "hide-list-splitter": _vm.hideListSplitter,
                              "delete-splitter": function($event) {
                                _vm.showDeleteSplitterDialog = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "transition",
                { attrs: { name: "fadeInsidePlan", mode: "out-in" } },
                [
                  _vm.visibleData === "insidePlan"
                    ? _c(
                        "v-layout",
                        {
                          key: "inside-plan-container-" + _vm.objectUuid,
                          staticClass: "inside-plan-container mt-4 pl-2 pr-2",
                          attrs: {
                            id: "inside-plan-container-" + _vm.objectUuid
                          }
                        },
                        [
                          _c("selected-drawer", {
                            attrs: {
                              connections: _vm.allConnections,
                              cassettes: _vm.cassettes,
                              "show-save-button": false
                            },
                            on: {
                              "open-tray-connection-menu":
                                _vm.openTrayConnectionMenu,
                              "open-tube-form": _vm.openAddTubeFiberForm,
                              "open-cassette-form": _vm.openCassetteForm,
                              "open-delete-cassette-dialog":
                                _vm.openDeleteCassetteDialog
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.editionFormIsOpen
            ? _c("splitter-edition-form", {
                attrs: {
                  open: _vm.editionFormIsOpen,
                  "original-item": _vm.selectedSplitterData
                },
                on: { close: _vm.closeItemEdition, edit: _vm.editItem }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isCreateEquipmentFormOpen
            ? _c("create-connection-form", {
                attrs: {
                  open: _vm.isCreateEquipmentFormOpen,
                  "object-uuid": _vm.objectUuid,
                  "is-splitter": _vm.menu.selected.state === "splitter",
                  "origin-cables": _vm.origin.cables,
                  "destination-cables": _vm.destination.cables,
                  connections: _vm.connections,
                  "selected-connection-point":
                    _vm.menu.selected.connectionPoints,
                  splitters: _vm.splitters,
                  "object-endpoint": _vm.objectEndpoint,
                  "object-id": _vm.objectId,
                  "is-tech-local": _vm.isTechLocal,
                  side: _vm.menu.selected.side,
                  "network-level": _vm.networkLevel
                },
                on: {
                  "add-splitter": _vm.addSplitter,
                  "create-connection-splitter": _vm.createConnectionSplitter,
                  "select-item": _vm.splitterSelectItem,
                  "close-connect-to": _vm.closeConnectTo
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("app-dialog-box", {
            attrs: {
              open: _vm.showDeleteConnectionDialog,
              title: _vm.$t("Remove") + " " + _vm.$tc("Connection", 1),
              content: "Are you sure you want to continue with this action?",
              "main-action-label": _vm.$t("No"),
              "secondary-action-label": _vm.$t("Yes")
            },
            on: {
              mainAction: _vm.cancelDeleteConnection,
              secondaryAction: _vm.confirmDeleteConnections
            }
          }),
          _vm._v(" "),
          _c("app-dialog-box", {
            attrs: {
              open: _vm.showDeleteSplitterDialog,
              title: _vm.$t("Remove") + " " + _vm.$tc("Equipment", 1),
              content: "Are you sure you want to continue with this action?",
              "main-action-label": _vm.$t("No"),
              "secondary-action-label": _vm.$t("Yes")
            },
            on: {
              mainAction: function($event) {
                _vm.showDeleteSplitterDialog = false
              },
              secondaryAction: _vm.removeSplitter
            }
          }),
          _vm._v(" "),
          _c("app-dialog-box", {
            attrs: {
              open: _vm.showPreviousConnectionsDialog,
              title: _vm.$t("RemovePreviousSplicingConnections.Title"),
              content: _vm.previousConnectionsDialogMessage,
              "main-action-label": _vm.$t("No"),
              "secondary-action-label": _vm.$t("Yes")
            },
            on: {
              mainAction: _vm.cancelNewSingleConnection,
              secondaryAction: _vm.continueCreatingConnections
            }
          }),
          _vm._v(" "),
          _c("app-dialog-box", {
            attrs: {
              open: _vm.showMultipleNewConnectionsDialog,
              title: _vm.$t("MultipleNewSplicingConnections.Title"),
              content: _vm.multipleNewConnectionsDialogMessage,
              "main-action-label": _vm.$t("No"),
              "secondary-action-label": _vm.$t("Yes")
            },
            on: {
              mainAction: _vm.cancelNewMultipleConnection,
              secondaryAction: function($event) {
                return _vm.continueCreatingConnections(true)
              }
            }
          }),
          _vm._v(" "),
          _c("loading-spinner", {
            attrs: {
              active: _vm.loading,
              "is-full-page": false,
              color: "accent",
              "background-color": "transparent"
            },
            on: {
              "update:active": function($event) {
                _vm.loading = $event
              }
            }
          }),
          _vm._v(" "),
          _vm.trayConnectionMenu.isOpen
            ? _c("tray-connection-menu", {
                attrs: {
                  horizontal: _vm.menuHorizontalPostion,
                  vertical: _vm.menuVerticalPosition
                },
                on: {
                  "edit-fiber": function($event) {
                    return _vm.openEditTubeFiberForm("fiber")
                  },
                  "edit-tube": function($event) {
                    return _vm.openEditTubeFiberForm("tube")
                  },
                  "remove-fiber": function($event) {
                    return _vm.openDeleteTubeFiberDialog("fiber")
                  },
                  "remove-tube": function($event) {
                    return _vm.openDeleteTubeFiberDialog("tube")
                  }
                }
              })
            : _vm.addTubeFiberForm.isOpen
            ? _c("add-tube-fiber-form", {
                attrs: {
                  "dialog-is-open": _vm.addTubeFiberForm.isOpen,
                  "available-fibers": _vm.availableFibers(
                    _vm.origin.cables,
                    _vm.destination.cables
                  )
                },
                on: {
                  "add-object": _vm.addTubeFiber,
                  "close-form": _vm.closeAddTubeFiberForm
                }
              })
            : _vm.editTubeFiberForm.isOpen
            ? _c("edit-tube-fiber-form", {
                attrs: {
                  "dialog-is-open": _vm.editTubeFiberForm.isOpen,
                  "fiber-type-options": _vm.fiberTypeOptions,
                  "object-data": _vm.editTubeFiberForm.fiberData,
                  "object-type": _vm.editTubeFiberForm.objectTypeToEdit
                },
                on: {
                  "edit-object": _vm.editTubeFiber,
                  "close-form": _vm.closeEditTubeFiberForm
                }
              })
            : _vm.tubeFiberDialog.isOpen
            ? _c("delete-tube-fiber-dialog", {
                attrs: { "dialog-is-open": _vm.tubeFiberDialog.isOpen },
                on: {
                  "cancel-delete": _vm.closeTubeFiberDialog,
                  "confirm-delete": _vm.deleteTubeFiber
                }
              })
            : _vm.deleteCassetteDialog.isOpen
            ? _c("delete-cassette-dialog", {
                attrs: {
                  "dialog-is-open": _vm.deleteCassetteDialog.isOpen,
                  "cassette-label": _vm.deleteCassetteDialog.cassetteLabel
                },
                on: {
                  "cancel-delete": _vm.closeDeleteCassetteDialog,
                  "confirm-delete": _vm.confirmDeleteCassette
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.cassetteForm.isOpen
            ? _c("add-or-edit-cassette-form", {
                attrs: {
                  "dialog-is-open": _vm.cassetteForm.isOpen,
                  "item-to-edit": _vm.objectToEdit,
                  "cassette-options": _vm.cassetteMaterialsOptions
                },
                on: {
                  "create-cassette": _vm.saveCassette,
                  "edit-cassette": _vm.saveCassette,
                  "close-cassette-form": _vm.closeCassetteForm
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa169c06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa169c06","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/SplicingTab.vue
// module id = null
// module chunks = 